// extracted by mini-css-extract-plugin
export default {"exitButton":"PricingTooltip_exitButton__tz-wr","header":"PricingTooltip_header__oYrIu","bodyContent":"PricingTooltip_bodyContent__RweRC"};